﻿document.addEventListener('DOMContentLoaded', () => {
    const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('#navbar-burger'), 0);

    if ($navbarBurgers.length > 0) {
        $navbarBurgers.forEach(el => {
            el.addEventListener('click', () => {
                const target = el.dataset.target;
                const $target = document.getElementById(target);
                el.classList.toggle('is-active');
                $target.classList.toggle('is-active');
            });

            document.addEventListener('click', (event) => {
                const target = el.dataset.target;
                const $target = document.getElementById(target);
                const $innerTarget = document.getElementById('navbar-start');

                var isClickInside = false;

                if ($innerTarget.contains(event.target) || el.contains(event.target)) {
                    isClickInside = true;
                }

                if (!isClickInside) {
                    el.classList.remove('is-active');
                    $target.classList.remove('is-active');
                }
            });
        });
    }
});
